import { useMsal } from "@azure/msal-react";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
//redux
import { useDispatch } from "react-redux";
import notificationService from "services/notificationService";
import { IS_AZURE } from "store/auth/login/actionTypes";
import { logoutUser } from "../../store/actions";

const FCM_DEVICE_TOKEN_KEY = "FCM_DEVICE_TOKEN";

const Logout = props => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  useEffect(() => {
    const handleLogout = async () => {
      const fcmDeviceToken = localStorage.getItem(FCM_DEVICE_TOKEN_KEY);
      if (fcmDeviceToken) {
        try {
          await notificationService.removeDeviceToken({
            device_token: fcmDeviceToken,
          });
        } catch (error) {}
      }

      dispatch(logoutUser(props.history, true));
      const isAzure = localStorage.getItem(IS_AZURE);
      if (isAzure === IS_AZURE) {
        localStorage.removeItem(IS_AZURE);
        instance.logoutPopup({
          postLogoutRedirectUri: "/login",
          mainWindowRedirectUri: "/login",
        });
      } else {
        window.location.href = "/login";
      }
    };

    handleLogout();
  }, [dispatch]);

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default Logout;
